import {
  SettingsLayoutSkeleton,
  SuspensePageBoundary,
} from "@-/dev.improve.haniverse.components.ui.suspense-page";
import { AboutSettingsPageContent } from "#about-settings-page-content";

export function AboutSettingsPage() {
  return (
    <SuspensePageBoundary fallback={<SettingsLayoutSkeleton />} location={import.meta.location}>
      <AboutSettingsPageContent />
    </SuspensePageBoundary>
  );
}
